import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import dayjs, { Dayjs } from "dayjs";
import { usePrintReport } from "../../Details/hooks/usePrintReport";
import { useMemo } from "react";
import { ButtonType } from "antd/es/button";

type PrintHistoryBtnProps = {
  accountNumber: number;
  range: [Dayjs, Dayjs];
  type?: ButtonType;
  disabled?: boolean;
};

export const PrintHistoryBtn = ({
  range,
  accountNumber,
  type = "default",
  disabled = false,
}: PrintHistoryBtnProps) => {
  const request = useMemo(
    () => ({
      beginYear: dayjs(range[0]).year(),
      endYear: dayjs(range[1]).year(),
    }),
    [range],
  );

  const { print, isLoading } = usePrintReport(
    request,
    accountNumber,
    "PaymentHistoryReport",
    "History Report",
  );

  return (
    <Button
      icon={<DownloadOutlined />}
      shape="round"
      type={type}
      disabled={disabled || isLoading}
      onClick={print}
    >
      History
    </Button>
  );
};
